import { render, staticRenderFns } from "./spiderModule.vue?vue&type=template&id=2a8b9354&scoped=true"
import script from "./spiderModule.vue?vue&type=script&lang=js"
export * from "./spiderModule.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a8b9354",
  null
  
)

export default component.exports